export function getLPM(cc, rpm){
  return (cc * rpm) / 1000;
}

export function getCC(l, rpm){
  return (l * 1000) / rpm;
}

export function getRPM(cc, liters){
  return (cc) / 1000 * liters;
}
